import {iContent, iSection, sectionType} from "@/Engine/apiInterfaces";
import {Item} from "@/Engine/Item";
import {Vector3} from "three";
import {modelMeta, modelNamesT} from "@/Constants/modelMeta";
import {$} from "@/Engine/state";
import {changeTextureCustom} from "@/Engine/changeTexture";
export class Door extends Item {
    name: modelNamesT;
    width: number;
    isOpen: 'o' | 'c' = 'o';

    constructor(doorName: modelNamesT, doorColor: string, width: number, showDoors: boolean) {
        super({blender_name:  doorName} as iSection);
        this.width = width;
        this.name = doorName;
        this.setColor(doorColor);
        this.position = new Vector3();
        // this.position = new Vector3(width-0.038, 0.055, 0.495);
        if (showDoors) {
            this.close();
        } else {
            this.open();
        }

    }

    open() {
        this.isOpen = 'o';
        this.yRotation = Math.PI/2;
        this.onUpdate();
    }

    close() {
        this.isOpen = 'c';
        this.yRotation = 0;
        this.onUpdate();
        // this._model.rotateY(Math.PI/2);
    }

    onUpdate() {
        const newName = (this.name as string)
            .replace('01', '11')
            .replace('02', '12')
            .replace('03', '13')
            .replace('04', '14')
            .replace('_u', '')
            + '_' + this.isOpen + '_AO.jpg';

        const aoPath = 'AO/' + modelMeta[this.name].width + '/ml/' + newName;
        console.log('Door: ' + aoPath);
        $.textureLoader
            .loadAsync(aoPath)
            .then((texture)=>{
                changeTextureCustom(this._model.material, 'AO', texture)
            })
            .catch((err)=>{
                console.log(aoPath);
                console.error(err);
            })
    }
}
